var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendarbooking = function SvgCalendarbooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.207 2.64h1.67c.516 0 .91.425.91.91v12.54c0 .485-.394.91-.91.91H1.91A.913.913 0 0 1 1 16.09V3.55c0-.485.395-.91.91-.91h2.52M10.229 2.64h2.186M6.253 2.64h2.155M1.06 6.981h15.697",
    stroke: "#1E1F23",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.492 1v3.552M12.477 1v3.552M8.5 1v3.552",
    stroke: "#1E1F23",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.619 11.808h-.274v.273h.274v-.273ZM4.19 11.808h-.274v.273h.273v-.273ZM9.046 11.808h-.273v.273h.273v-.273ZM11.476 11.808h-.273v.273h.273v-.273ZM13.903 11.808h-.273v.273h.273v-.273ZM6.618 9.379h-.273v.273h.273v-.273ZM9.046 9.379h-.273v.273h.273v-.273ZM11.476 9.379h-.273v.273h.273v-.273ZM13.905 9.379h-.273v.273h.273v-.273ZM6.619 14.206h-.274v.273h.274v-.273ZM4.19 14.206h-.274v.273h.273v-.273ZM9.046 14.206h-.273v.273h.273v-.273ZM11.476 14.206h-.273v.273h.273v-.273Z",
    fill: "#1E1F23",
    stroke: "#1E1F23",
    strokeMiterlimit: 10
  })));
};

export default SvgCalendarbooking;